import React from 'react';
import Main from './Main';

 
class App extends React.Component{

state={start:false}

Onclick=(event)=>{
 this.setState({start:true})
}

 render(){
 	if(this.state.start){
 		return(
 			<Main/>
 			)
 	}else{
 	return(
 		<div style={{backgroundColor:'#7FFFD4',
 		height:'100vh',
 		display:'flex',
 		justifyContent:'center',
 		alignItems:'center'}}>
 			<button className='ui teal large button' onClick={this.Onclick}> Get started </button>
 		</div>
 		)
 	}
 }
}

export default App;